import { render, staticRenderFns } from "./ModalReceberReceita.vue?vue&type=template&id=5b78a966&"
import script from "./ModalReceberReceita.vue?vue&type=script&lang=js&"
export * from "./ModalReceberReceita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports